import leaderboard from '../mocks/leaderboard.json';

const ysdkMock = {
    adv: {
        showFullscreenAdv: (options: any) => {
            options.callbacks.onClose();
        },
        showRewardedVideo: (options: any) => {
            options.callbacks.onRewarded();
            options.callbacks.onClose();
        }
    },
    getPlayer: () => Promise.resolve({
        getData: () => Promise.resolve({
            onboarded: true
        }),
        getMode() {
            return 'lite';
        },
        setData: (data: any) => {
            console.info('saved data - ', JSON.stringify(data));

            return Promise.resolve();
        }
    })
};

const YaGamesMock = {
    init: () => Promise.resolve(ysdkMock)
}

export default class Sdk {
    private player?: any;
    private ysdk?: any;
    private leaderboard?: LeaderboardResponse;
    private isMock: boolean = false; 

    init(): Promise<void> {
        if (!window.YaGames) {
            console.info('Yandex SDK not available');

            window.YaGames = YaGamesMock;
            this.isMock = true;
        }

        return window.YaGames.init().catch((error: Error) => {
            // TODO: Сделать попап об ошибке 
            console.error('SDK initialization error');

            throw error;
        }).then((ysdk: any) => {
            console.info('SDK initialized', ysdk);

            this.ysdk = ysdk;

            return this.getPlayer();
        });
    }

    public getLang() {
        return this.ysdk?.environment?.i18n.lang || 'en';
    }

    private async fetchLeaderboard(): Promise<LeaderboardResponse> {
        this.leaderboard = await this.ysdk.getLeaderboards();

        return this.leaderboard!;
    }

    public async getLeaderboardPlayerEntry(): Promise<LeaderboardPlayerResponse> {
        if (!this.leaderboard) {
            await this.fetchLeaderboard();
        }

        return await this.leaderboard!.getLeaderboardPlayerEntry('topScore');
    }

    public async setLeaderboardData(score: number) {
        if ((await this.getPlayer()).getMode() === 'lite') {
            return;
        }

        if (!this.leaderboard) {
            await this.fetchLeaderboard();
        }

        await this.leaderboard!.setLeaderboardScore('topScore', score);
    }

    public async getLeaderboardEntries(): Promise<LeaderboardEntriesResponse> {
        if (this.isMock) {
            return Promise.resolve(leaderboard as any);
        }
        if (!this.leaderboard) {
            await this.fetchLeaderboard();
        }

        return await this.leaderboard!.getLeaderboardEntries('topScore', { includeUser: true });
    }

    public ready() {
        this.ysdk?.features?.LoadingAPI.ready();
    }

    getPlayer(): Promise<IPlayer> {
        return this.ysdk.getPlayer().then((_player: any) => {
            console.info('Player initialized');

            this.player = _player;
            return _player;
        }).catch((error: Error) => {
            console.error('Player initialization error');

            throw error;
        });
    }

    getPlayerData(): Promise<Record<string, any>> {
        if (!this.player) {
            return Promise.reject();
        }

        return this.player.getData();
    }

    setPlayerData(data: Record<string, any>): Promise<Record<string, any>> {
        if (!this.player) {
            return Promise.reject();
        }

        return this.player.setData(data).then(() => {
            console.info('Data saved');
        }).catch(() => {
            console.error('Data saved error');
        });
    }

    showFullscreenAdv() {
        return new Promise(resolve => {
            this.ysdk.adv.showFullscreenAdv({
                callbacks: {
                    onClose: () => {
                        resolve(null);

                        console.info('Adv closed');
                    },
                    onError: () => {}
                }
            })
        })
    }

    showRewardedVideo() {
        return new Promise((resolve, reject) => {
            this.ysdk.adv.showRewardedVideo({
                callbacks: {
                    onClose: () => {
                        reject(null);

                        console.info('Rewarded video closed');
                    },
                    onRewarded: () => {
                        resolve(null);

                        console.info('Rewarded received');
                    }
                }
            })
        })
    }
}


declare global {
    interface Window {
        YaGames: any;
    }
}

declare interface LeaderboardResponse {
    appID: string;
    default: boolean;
    description: {
      invert_sort_order: boolean;
      score_format: {
        options: {
          decimal_offset: integer;
        };
      };
      type: string;
    }
    name: string;
    title: {
      en: string;
      ru: string;
    };
    setLeaderboardScore: (
        leaderboardName: string,
        score: number,
        extraData?: string
    ) => void;
    getLeaderboardPlayerEntry: (leaderboardName: string) => LeaderboardPlayerResponse;
    getLeaderboardEntries: (
        leaderboardName: string,
        { includeUser, quantityAround, quantityTop }: {
            includeUser?: boolean,
            quantityAround?: integer,
            quantityTop?: integer
        }
    ) => LeaderboardEntriesResponse;
}

export interface LeaderboardEntriesResponse {
    leaderboard: LeaderboardResponse;
    ranges: [
      {
        start: integer,
        size: integer
      }
    ],
    userRank: integer,
    entries: Array<LeaderboardEntry>;
}

export interface LeaderboardEntry {
    score: integer,
    extraData: string,
    rank: integer,
    player: {
      getAvatarSrc: (size: string) => string,
      getAvatarSrcSet: (size: string) => string,
      lang: string,
      publicName: string,
      scopePermissions: {
        avatar: string,
        public_name: string
      },
      uniqueID: string,
    },
  formattedScore: string
}

declare interface LeaderboardPlayerResponse {
    score: integer;
    extraData: string;
    rank: integer;
    player: {
      getAvatarSrc: (size: string) => string;
      getAvatarSrcSet: (size: string) => string;
      lang: string;
      publicName: string;
      scopePermissions: {
        avatar: string;
        public_name: string;
      };
      uniqueID: string;
    };
    formattedScore: string;
}

declare interface IPlayer {
    getMode: () => 'lite' | 'full'
}